<template>
	<div class="mb-4">
		<div class="d-flex align-center justify-space-between mb-1">
			<span class="text-caption text-medium-emphasis">{{ title }}</span>
			<v-btn size="x-small" variant="text" :icon="copied ? 'mdi-check' : 'mdi-content-copy'" @click="copy"></v-btn>
		</div>
		<pre class="snippet-pre"><code class="hljs" v-html="highlighted"></code></pre>
	</div>
</template>

<script setup>
import { computed, ref } from 'vue'
import hljs from 'highlight.js/lib/core'

const props = defineProps({
	title: { type: String, required: true },
	code: { type: String, required: true },
	language: { type: String, default: 'plaintext' },
})

const copied = ref(false)

function copy() {
	navigator.clipboard?.writeText(props.code)
	copied.value = true
	setTimeout(() => (copied.value = false), 1500)
}

const highlighted = computed(() => {
	if (hljs.getLanguage(props.language)) {
		return hljs.highlight(props.code, { language: props.language }).value
	}
	return hljs.highlightAuto(props.code).value
})
</script>

<style scoped>
.snippet-pre {
	margin: 0;
	border-radius: 8px;
	overflow: hidden;
	font-size: 0.8rem;
}

.snippet-pre :deep(code.hljs) {
	border-radius: 8px;
	margin: 0;
}
</style>
